import classNames from 'classnames';
import { AnimatedNumber, Spinner } from 'ui';
import { GetBalanceStatisticsResponse } from 'api';

export interface InvestorDashboardBalanceStatisticsProps {
  data?: GetBalanceStatisticsResponse;
  isLoading: boolean;
  numberOfInvestments: number;
}

export const InvestorDashboardBalanceStatistics = ({
  data,
  isLoading,
  numberOfInvestments = 0,
}: InvestorDashboardBalanceStatisticsProps) => {
  return (
    <div
      className={classNames(
        'w-full lg:flex p-3 sm:p-6 items-center justify-between',
        'border border-gray-200 rounded-xl gap-y-2',
        {
          'grid grid-cols-2': !(isLoading || !data),
        },
      )}
    >
      {isLoading || !data ? (
        <div className="w-full h-[150px] flex items-center justify-center">
          <Spinner size="lg" />
        </div>
      ) : (
        <>
          <div className="flex flex-col space-y-2">
            <p className="text-[14px] leading-[22px] text-gray-500">Portfolio value</p>
            <div className="text-[18px] leading-5 sm:text-[32px] sm:leading-[30px] flex items-center">
              <p>$</p>
              {data?.portfolio_value < 0 ? '-' : ''}
              <AnimatedNumber
                includeComma
                animateToNumber={Math.round(data?.portfolio_value * 100) / 100}
              />
            </div>
          </div>
          <div className="flex flex-col space-y-2 border-0 lg:border-l pl-0 lg:pl-6 border-gray-200">
            <p className="text-[14px] leading-[22px] text-gray-500">Performance</p>
            <div className="text-[18px] leading-5 sm:text-[32px] sm:leading-[40px] flex items-center">
              {data?.performance < 0 ? '-' : ''}
              <AnimatedNumber
                includeComma
                animateToNumber={Number(data?.performance?.toFixed(2))}
              />
              <p>%</p>
            </div>
          </div>
          <div className="flex flex-col space-y-2 border-0 lg:border-l pl-0 lg:pl-6 border-gray-200">
            <p className="text-[14px] leading-[22px] text-gray-500">Dividends received</p>
            <div className="text-[18px] leading-5 sm:text-[32px] sm:leading-[40px] flex items-center">
              <p>$</p>
              {data?.dividends_received < 0 ? '-' : ''}
              <AnimatedNumber
                includeComma
                animateToNumber={Math.round(data?.dividends_received * 100) / 100}
              />
            </div>
          </div>
          <div className="flex flex-col space-y-2 border-0 lg:border-l pl-0 lg:pl-6 border-gray-200">
            <p className="text-[14px] leading-[22px] text-gray-500">Number of investments</p>
            <div className="text-[18px] leading-5 sm:text-[32px] sm:leading-[40px]">
              {<AnimatedNumber includeComma animateToNumber={numberOfInvestments} />}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
